module.exports = __webpack_public_path__ + "media/63.9efcc007.mp3";